import { useContext } from "react";
import "../style/SignInScreen.module.scss";
import "react-phone-input-2/lib/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { AuthContext } from "../../../context/AuthContext";
import { useFormat, } from "../../../hooks/useFormat";
import * as Yup from 'yup';
import Swal from "sweetalert2";

export function useSignInScreen() {
    const { checkPassword } = useFormat();

    const { signIn, setAlert, errorMessage } = useContext(AuthContext)
    const route = useNavigate();
    const parameters = useLocation();

    const validate = Yup.object({
        password: Yup.string().required('Ingresa una contraseña.')
        .max(20,'Tu contraseña no debe exceder los 20 caracteres.')
        .min(6,'Tu contraseña debe tener al menos 6 caracteres.')
    })
    
    const formik = useFormik({
        initialValues: {
            username: parameters.state.phoneNumber,
            password: "",
        },
        onSubmit: async (values) => {
            let resp = await signIn(values)
            if (resp == true) {
                route("/")
            } else {
                Swal.fire({
                    showCloseButton: true,
                    title: 'Login incorrecto',
                    text: "Información incorrecta",
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#fd6e0d',
                    iconColor: "#fd6e0d",
                    confirmButtonText: 'Entendido'
                })
            }
        },
        validationSchema: validate
    });

    return {
        formik,
        parameters,
        route
    }
}